import { ReactNode } from 'react';

type BeneficiaryListWrapperProps = {
  beneficiariesLength: number;
  fallbackElement: ReactNode;
  children: ReactNode;
};

export const BeneficiaryListWrapper = ({
  beneficiariesLength,
  fallbackElement,
  children,
}: BeneficiaryListWrapperProps) => {
  if (beneficiariesLength === 0) {
    return fallbackElement;
  }

  return children;
};
